import React, { Fragment, useState, useEffect, useContext } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { appContext } from '../../../Utils/context';
import records from "../../../Services/records";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import { Button, } from "reactstrap";
import { toast, Slide } from "react-toastify";
import { error } from "jquery";

const getNavStates = (indx, length) => {
    let styles = [];
    for (let i = 0; i < length; i++) {
        if (i < indx) {
            styles.push("done");
        } else if (i === indx) {
            styles.push("doing");
        } else {
            styles.push("todo");
        }
    }
    return { current: indx, styles: styles };
};



export default function SetupUser() {
    const { user, setUser } = useContext(appContext)
    const [stateAndCounties, setStateAndCounties] = useState({});
    const [userData, setUserData] = useState({})
    const [validationErrors, setValidationErrors] = useState({});
    const [isChecked, setIsChecked] = useState({ check1: false, check2: false, check3: false, })
    // let state1 = { market_name: "", description: "", default: false, market_status: false }
    // const [market, setMarket] = useState(state1)


    const steps = [
        { name: "User", component: <Step1 userData={userData} setUserData={setUserData} validationErrors={validationErrors} /> },
        { name: "State and County", component: <Step2 stateAndCounties={stateAndCounties} setStateAndCounties={setStateAndCounties} /> },
        { name: "Terms & Conditions", component: <Step3 isChecked={isChecked} setIsChecked={setIsChecked} validationErrors={validationErrors} /> },
        { name: "Finish", component: <Step4 /> },

    ];

    const [showPreviousBtn, settingShowPreviousBtn] = useState(false)
    const [showNextBtn, settingShowNextBtn] = useState(true)
    const [compState, settingCompState] = useState(0)
    const [navState, settingNavState] = useState(getNavStates(0, steps.length))

    let showNavigation = true

    useEffect(() => {
        const extractedData = {
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            emai2: user.email,
            company_name:user.company_name,
            phone: user.phone,
            address: user.address,
            state: user.state,
            city: user.city,
            zip: user.zip,
        };
        setUserData(extractedData)

        // const dataObject = JSON.parse(user?.state_and_counties);
        // setStateAndCounties(dataObject || {})
        let dataObject = {};
        if (user?.state_and_counties) {
            dataObject = JSON.parse(user.state_and_counties);
        }
        setStateAndCounties(dataObject || {});
    }, [user])

    const checkNavState = (currentStep, stepsLength) => {
        if (currentStep > 0 && currentStep < stepsLength - 1) {
            settingShowPreviousBtn(true)
            settingShowNextBtn(true)

        } else if (currentStep === 0) {
            settingShowPreviousBtn(false)
            settingShowNextBtn(true)

        } else {
            settingShowPreviousBtn(false)
            settingShowNextBtn(false)
        }
    };

    const setNavState = (next) => {
        settingNavState(
            getNavStates(next, steps.length),
        );
        if (next < steps.length) {
            settingCompState(next);
        }
        checkNavState(next, steps.length);
    };

    // const handleKeyDown = (evt) => {
    //   console.log("handle key down", evt)
    //     if (evt.which === 13) {
    //       next();
    //     }
    //   };

    //  const handleOnClick = (evt) => {
    //     if (
    //       evt.currentTarget.value === steps.length - 1 &&
    //       compState === steps.length - 1
    //     ) {
    //       setNavState(steps.length);
    //     } else {
    //       setNavState(evt.currentTarget.value);
    //     }
    //   };

    const next = () => {
        if (compState === 0) {
            const errors = {};
            if (!userData?.first_name) {
                errors.first_name = "First name is required";
            }
            if (!userData?.last_name) {
                errors.last_name = "Last name is required";
            }
            if (!userData?.address) {
                errors.address = "Address is required";
            }
            if (!userData?.city) {
                errors.city = "City is required";
            }
            if (!userData?.state) {
                errors.state = "State is required";
            }
            if (!userData?.zip) {
                errors.zip = "Zip is required";
            }

            if (userData?.email2 && !validateEmail(userData?.email2)) {
                errors.email2 = "Invalid Email Address";
            }
            if (!userData?.phone) {
                errors.phone = 'Phone is required';
            } else if (!validatePhone(userData.phone)) {
                errors.phone = 'Invalid Phone Number';
            }

            setValidationErrors(errors);
            if (Object.keys(errors).length === 0) {
                setNavState(compState + 1);
            }
        }

        else if (compState === 1) {

            if (Object.keys(stateAndCounties).length !== 0) {
                setNavState(compState + 1);
            }
            else {
                notify22("Select Atleast 1 State & County", "warning");
            }
        }

        else if (compState === 2) {
            const errors = {};
            // if (market?.market_name === '') {
            //     errors.market_name = "Market name is required";
            // }
            if (!isChecked.check1 || !isChecked.check2 || !isChecked.check3) {
                errors.isChecked = "Please agree to all Terms and Conditions before proceeding";
            }
            setValidationErrors(errors);
            if (Object.keys(errors).length === 0) {
                // Create an array of promises for the two API calls
                const promises = [
                    records.UpdateUserProfile({ ...userData, state_and_counties: JSON.stringify(stateAndCounties) }),
                    // records.addMarket(market),
                ];

                Promise.all(promises)
                    .then(([updateUserResponse, addMarketResponse]) => {
                        // Both API calls were successful
                        // console.log("Profile Updated", updateUserResponse?.data);
                        // console.log("Market added", addMarketResponse?.data);
                        notify22("User Setup Wizard has Completed!", "success");
                        setUser(updateUserResponse?.data)
                        //  setMarket(state1)


                        // Call setNavState(compState + 1) here
                        setNavState(compState + 1);
                    })
                    .catch((error) => {
                        console.error("API Error:", error);
                        notify22("User Setup Wizard has Failed!", "error");

                        // Handle errors here, if needed
                    });
            }
        }


    };

    const previous = () => {
        if (compState > 0) {
            setNavState(compState - 1);
        }
    };

    const getClassName = (className, i) => {
        return className + "-" + navState.styles[i];
    };

    const renderSteps = () => {
        return steps.map((s, i) => (
            <li
                className={getClassName("form-wizard-step", i)}
                // onClick={handleOnClick}
                key={i}
                value={i}
            >
                <em>{i + 1}</em>
                <span >{steps[i].name}</span>
            </li>
            //   className="d-none d-sm-block"
        ));
    };

    const validateEmail = (email) => {
        const emailPattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;

        return emailPattern.test(email);
    };

    const validatePhone = (phone) => {
        const phonePattern = RegExp(/\(\d{3}\) \d{3}-\d{4}/);

        return phonePattern.test(phone);
    };

    const notify22 = (msg, type) =>
        toast(msg, {
            transition: Slide,
            autoClose: 5000,
            position: "top-right",
            type: type,

        });


    return (
        <Fragment>
            <TransitionGroup>
                <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                    timeout={0} enter={false} exit={false}>
                    <div>
                        <ol className="forms-wizard">{renderSteps()}</ol>
                        {steps[compState].component}
                        <div className="divider" />
                        <div className="clearfix">
                            <div style={showNavigation ? {} : { display: "none" }}>
                                <Button color="secondary" className="btn-shadow float-start btn-wide btn-pill" outline
                                    style={showPreviousBtn ? {} : { display: "none" }} onClick={previous}>
                                    Previous
                                </Button>
                                <Button color="primary" className="btn-shadow btn-wide float-end btn-pill btn-hover-shine"
                                    style={showNextBtn ? {} : { display: "none" }} onClick={next}>
                                    Next
                                </Button>
                            </div>
                        </div>
                    </div>


                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    );

}
